import gql from 'graphql-tag';
// import { storeBasicFields } from './GetStore';

export const roleFields = `
  id
  name
  group
  precedence
`;

export const basicMemberFields = `
    id
    memberNo
    avatar {
      filename
      uploader
    }
    email
    firstName
    middleName
    lastName
    inactive
    employmentType
    status
`;

export const memberFields = `
    ${basicMemberFields}
    role {
      ${roleFields}
    }
    manager{
      ${basicMemberFields}
    }
    store {
      id
      name
      type
    }
`;

const key = 'GetMember';
const query = gql`
query ${key}($memberId: ID!, $memberNextToken: String, $limit: Int = 50) {
  getMember(id: $memberId){
    ${memberFields}
    members(nextToken: $memberNextToken, limit: $limit){
      nextToken
      items{
        ${basicMemberFields}
        role {
          ${roleFields}
        }
        manager{
          id
        }
        store{
          id
          name
          type
        }
      }
    }
  }
  listRoles(limit:200){
    items{
      id
      name
      group
    }
  }
}
`;

export const GET_MEMBER = { key, query };

const getMemberWithCognitoUserKey = 'GetMemberWithCognitoUser';
const getMemberWithCognitoUserQuery = gql`
query ${getMemberWithCognitoUserKey}($memberId: ID!) {
  getMember(id: $memberId){
    id
    ${memberFields}
    cognitoUser{
      status
      Username
      Email
    }
  }
}
`;

export const GET_MEMBER_WITH_COGNITO_USER = {
  key: getMemberWithCognitoUserKey,
  query: getMemberWithCognitoUserQuery
};
